module.exports = __webpack_public_path__ + "public/img/ico-schematics-grid-shadow.32109240.svg";